import { h } from "preact";
import { useState } from "preact/hooks";
import copyToC from "copy-to-clipboard";
import cn from "classnames";

import Connect from "../Connect";
import Mint from "../Mint";
import Roadmap from '../Roadmap'

import { accountToReferralCode } from "../Refs/utils";

import s from "./style.css";
import sU from "../utils.css";

function RefsButton({ account, connect }) {
  const [isCopied, setCopied] = useState(false);

  const code = accountToReferralCode(account);
  const link = `${window.location.href}/?ref=${code}`;

  function copy() {
    copyToC(link);
    setCopied(true);

    setTimeout(() => setCopied(false), 1000);
  }

  if (account) {
    return (
      <button type="button" class={s.refButton} onClick={copy}>
        {isCopied ? "Copied" : "Copy link"}
      </button>
    );
  }

  return <Connect connect={connect} class={s.button} />;
}

const DiscordIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24px"
    height="24px"
  >
    <g id="surface182580846">
      <path
        style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;"
        d="M 19.980469 5.167969 C 18.070312 3.632812 15.046875 3.371094 14.917969 3.363281 C 14.71875 3.34375 14.527344 3.457031 14.441406 3.644531 C 14.4375 3.65625 14.371094 3.804688 14.296875 4.042969 C 15.5625 4.257812 17.113281 4.6875 18.515625 5.558594 C 18.742188 5.695312 18.8125 5.992188 18.671875 6.21875 C 18.582031 6.367188 18.425781 6.445312 18.265625 6.445312 C 18.179688 6.445312 18.089844 6.421875 18.011719 6.375 C 15.597656 4.875 12.582031 4.800781 12 4.800781 C 11.417969 4.800781 8.402344 4.875 5.988281 6.375 C 5.765625 6.515625 5.46875 6.445312 5.328125 6.21875 C 5.1875 5.992188 5.257812 5.699219 5.484375 5.558594 C 6.886719 4.6875 8.4375 4.257812 9.703125 4.042969 C 9.628906 3.804688 9.5625 3.65625 9.558594 3.644531 C 9.472656 3.457031 9.285156 3.339844 9.082031 3.363281 C 8.953125 3.371094 5.929688 3.632812 3.992188 5.191406 C 2.984375 6.125 0.960938 11.59375 0.960938 16.320312 C 0.960938 16.40625 0.984375 16.484375 1.023438 16.558594 C 2.417969 19.011719 6.226562 19.652344 7.09375 19.679688 C 7.097656 19.679688 7.105469 19.679688 7.109375 19.679688 C 7.265625 19.679688 7.40625 19.605469 7.5 19.484375 L 8.375 18.277344 C 6.007812 17.664062 4.796875 16.625 4.730469 16.5625 C 4.53125 16.390625 4.511719 16.085938 4.6875 15.886719 C 4.863281 15.6875 5.164062 15.667969 5.363281 15.84375 C 5.390625 15.871094 7.621094 17.761719 12 17.761719 C 16.386719 17.761719 18.613281 15.863281 18.636719 15.84375 C 18.835938 15.671875 19.136719 15.6875 19.3125 15.890625 C 19.488281 16.085938 19.46875 16.390625 19.269531 16.5625 C 19.203125 16.625 17.992188 17.664062 15.625 18.277344 L 16.5 19.484375 C 16.59375 19.605469 16.734375 19.679688 16.890625 19.679688 C 16.894531 19.679688 16.902344 19.679688 16.90625 19.679688 C 17.773438 19.652344 21.582031 19.011719 22.976562 16.558594 C 23.015625 16.484375 23.039062 16.40625 23.039062 16.320312 C 23.039062 11.59375 21.015625 6.125 19.980469 5.167969 Z M 8.878906 14.398438 C 7.953125 14.398438 7.199219 13.542969 7.199219 12.480469 C 7.199219 11.417969 7.953125 10.558594 8.878906 10.558594 C 9.808594 10.558594 10.558594 11.417969 10.558594 12.480469 C 10.558594 13.542969 9.808594 14.398438 8.878906 14.398438 Z M 15.121094 14.398438 C 14.191406 14.398438 13.441406 13.542969 13.441406 12.480469 C 13.441406 11.417969 14.191406 10.558594 15.121094 10.558594 C 16.046875 10.558594 16.800781 11.417969 16.800781 12.480469 C 16.800781 13.542969 16.046875 14.398438 15.121094 14.398438 Z M 15.121094 14.398438 "
      />
    </g>
  </svg>
);

const TwitterIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24px"
    height="24px"
  >
    <g id="surface182783005">
      <path
        style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;"
        d="M 24.03125 5.011719 C 23.144531 5.402344 22.191406 5.667969 21.191406 5.789062 C 22.214844 5.175781 22.996094 4.210938 23.363281 3.058594 C 22.410156 3.621094 21.351562 4.03125 20.230469 4.253906 C 19.328125 3.292969 18.046875 2.695312 16.628906 2.695312 C 13.902344 2.695312 11.691406 4.90625 11.691406 7.632812 C 11.691406 8.015625 11.734375 8.394531 11.820312 8.757812 C 7.71875 8.550781 4.082031 6.585938 1.644531 3.597656 C 1.21875 4.328125 0.980469 5.175781 0.980469 6.082031 C 0.980469 7.792969 1.847656 9.304688 3.175781 10.191406 C 2.363281 10.164062 1.601562 9.941406 0.9375 9.570312 C 0.9375 9.59375 0.9375 9.613281 0.9375 9.632812 C 0.9375 12.027344 2.640625 14.019531 4.894531 14.476562 C 4.484375 14.585938 4.046875 14.648438 3.597656 14.648438 C 3.277344 14.648438 2.96875 14.617188 2.667969 14.558594 C 3.296875 16.515625 5.117188 17.949219 7.277344 17.988281 C 5.589844 19.3125 3.460938 20.097656 1.148438 20.097656 C 0.75 20.097656 0.355469 20.074219 -0.0273438 20.027344 C 2.15625 21.429688 4.75 22.246094 7.539062 22.246094 C 16.617188 22.246094 21.582031 14.726562 21.582031 8.203125 C 21.582031 7.992188 21.574219 7.777344 21.566406 7.566406 C 22.53125 6.871094 23.367188 6 24.03125 5.011719 Z M 24.03125 5.011719 "
      />
    </g>
  </svg>
);

const Description = ({ class: className }) => {
  return (
    <p class={className}>
      AAC is a collection of 10,000 ArbiApe NFTs—unique digital collectibles
      living on the L2 Arbitrum blockchain. <br />
      ArbiApes are a fairly launched fork of Ethereum's BAYC. <br />
      They are ERC-721 tokens fully integrated and supported on the Arbitrum
      network, and will be listed on all major NFT marketplaces.
    </p>
  );
};

const Img = ({ class: className }) => (
  <img src="/assets/overview.png" class={cn(s.img, className)} />
);

const Icons = ({ class: className }) => (
  <div class={cn(s.icons, className)}>
    <a href="https://twitter.com/ArbiApeClub" target="_blank">
      <TwitterIcon />
    </a>
    <a href="https://discord.gg/ha4cqFgktD" target="_blank">
      <DiscordIcon />
    </a>
  </div>
);

export default function ({ account, chainId, error, provider, connect, refId }) {
  return (
    <div>
      <div class="container">
        <div class="hero">
          <div class="row">
            <div class="col-xs-12 col-md-7">
              <div class="about">
                <Icons class={sU.hiddenMd} />
                <Connect
                  account={account}
                  connect={connect}
                  class={sU.hiddenMd}
                />
                <h1 class={s.heading}>
                  WELCOME TO THE <br />
                  ARBIAPE L2 CLUB
                </h1>
                <Img class={sU.hiddenMd} />
                <Mint
                  account={account}
                  chainId={chainId}
                  error={error}
                  provider={provider}
                  connect={connect}
                  refId={refId}
                  class={sU.hiddenMd}
                />

                <h2 class={cn(s.smallHeading, sU.hiddenMd)}>MEET THE APES</h2>
                <Description />

                <div class={s.features}>
                  <div>
                    <h2 class={s.smallHeading}>FAIR DISTRIBUTION</h2>
                    <p class={s.smallText}>
                      There are no bonding curves here. Buying an ArbiApe costs
                      0.05 ETH. There are no price tiers.
                    </p>
                  </div>
                  <div>
                    <h2 class={s.smallHeading}>REFERRALS</h2>
                    <p class={s.smallText}>
                      You know the drill: share your link and get 15% on all
                      minted ArbiApes:
                      <br />
                      <RefsButton account={account} connect={connect} />
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-5">
              <div class={s.social}>
                <div class={sU.visibleMd}>
                  <Connect
                    account={account}
                    connect={connect}
                  />
                </div>
                <Icons class={sU.visibleMd} />
                <Img class={sU.visibleMd} />
              </div>
            </div>
          </div>
        </div>

        <Mint
          account={account}
          chainId={chainId}
          error={error}
          provider={provider}
          connect={connect}
          refId={refId}
          class={sU.visibleMd}
        />

        <Roadmap />
      </div>
    </div>
  );
}
